module.exports = __webpack_public_path__ + "static/media/QRdownload.f4e6597f.png";